<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <SignaturePad
            :showSignaturePad="showSignaturePadClient"
            @close="showSignaturePadClient = false"
            @signatureData="signatureDataClient"
        />

        <SignaturePad
            :showSignaturePad="showSignaturePadGuardian"
            @close="showSignaturePadGuardian = false"
            @signatureData="signatureDataGuardian"
        />

        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-tabs v-model="tab">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab v-for="(item, index) in items" :key="index">
                            {{ item }}
                            <v-chip class="ml-2" color="green" text-color="white" small>
                                {{ index === 0 ? activeRights : fadedRights }}
                            </v-chip>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="(item, i) in items" :key="item">
                            <v-card class="pa-2" outlined tile height="100%">
                                <template>
                                    <v-data-table
                                        :headers="headers"
                                        :items="i === 0 ? rights : faded"
                                        sort-by="ReviewDate"
                                        sort-desc
                                        :loading="isLoading"
                                        loading-text="Loading Human Rights Restrictions"
                                        height="550"
                                        :search="search"
                                        :server-items-length="totalServerItems"
                                        @update:options="getRights"
                                    >
                                        <template v-slot:top>
                                            <v-toolbar flat color="white">
                                                <v-toolbar-title>Human Rights</v-toolbar-title>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                <v-spacer></v-spacer>
                                                <v-text-field
                                                    v-model="search"
                                                    clearable
                                                    flat
                                                    solo-inverted
                                                    hide-details
                                                    prepend-inner-icon="search"
                                                    label="search"
                                                    class="desktop"
                                                    dense
                                                    height="20"
                                                    @keyup.enter="searchItem(search)"
                                                    @change="searchItem(search)"
                                                >
                                                    <!-- <template v-slot:append>
                                                    <v-btn color="primary" class="mr-n3" @click="searchItem(search)">search</v-btn>
                                                    </template> -->
                                                </v-text-field>
                                                <v-spacer></v-spacer>
                                              <v-btn v-if="!directCare && !isAuditorRole" color="#2b3990" dark @click="showAdd()">
                                                <v-icon left>add</v-icon>
                                                <span class="hidden-sm-and-down">Add Restriction</span>
                                                <span class="hidden-md-and-up">Add</span>
                                              </v-btn>
                                              <v-btn v-if="!directCare" class="primary ml-3" @click="printTable()">
                                                <v-icon small>print</v-icon>
                                                <span class="hidden-sm-and-down">Print</span>
                                              </v-btn>
                                            </v-toolbar>
                                            <v-text-field
                                                v-model="search"
                                                clearable
                                                flat
                                                solo-inverted
                                                hide-details
                                                prepend-inner-icon="search"
                                                label="search"
                                                class="mobile ml-5 mr-5 mb-3 mt-3"
                                            ></v-text-field>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon small class="mr-2" @click="viewRight(item)">
                                                mdi-eye
                                            </v-icon>
                                            <!-- <v-icon small class="mr-2" @click="editRight(item)">
                                            mdi-pencil
                                            </v-icon> -->
                                            <v-icon small @click="deleteRight(item)" v-if="!directCare && !isAuditorRole">
                                                mdi-delete
                                            </v-icon>
                                            <!-- <v-icon small @click="addDeal(item)">
                                            add
                                            </v-icon> -->
                                        </template>
                                        <template v-slot:no-data>
                                            <v-btn color="#2b3990" class="white--text" @click="getRights()">Reset</v-btn>
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printTable">
            <h2 class="text-center ma-3">{{ clientName }}'s' Human Rights Restriction</h2>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="printHeaders"
                        :items="rights"
                        sort-by="ReviewDate"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Human Rights Restrictions"
                        :search="search"
                        height="auto"
                        hide-default-footer
                        disable-pagination
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Human Rights Restrictions</v-toolbar-title>
                            </v-toolbar>

                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>

        <div id="printItem">

            <h2> {{ clientName }}'s Human Rights Restrictions</h2>
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="newReviewDate"
                                label="Review Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newReviewDate"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu3 = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu3.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>

                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="newDateExpires"
                                label="Date Expires"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newDateExpires"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu4 = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu4.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12">

                    <v-card-title>Restriction</v-card-title>
                    <v-divider></v-divider>

                    <v-card-subtitle>Specific and individualized assessed need. If applicable, a way for other
                        individuals to circumvent.
                    </v-card-subtitle>

                    <v-col cols="12">
                        <v-text-field
                            outlined
                            v-model="newRestriction"
                        ></v-text-field>

                    </v-col>

                    <!-- <v-col cols="12">
                      <v-file-input
                        v-model="newDocument"
                        class="pa-2"
                        label="Select documents to upload"
                        show-size
                        filled
                        multiple
                        prepend-icon="mdi-camera"
                        accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="fileSelected"

                      >
                        <template #selection="{ text, index }">
                          <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                        </template>
                      </v-file-input>
                    </v-col> -->

                    <v-col cols="12" sm="12" md="3"
                           v-for="doc in newDocument"
                           :key="doc.awsLink"
                    >
                        <!-- <v-img
                          max-height="80"
                          max-width="150"
                          :src="doc.awsLink"
                        ></v-img> -->
                        <img :src="doc.awsLink" width="150" height="75">
                        <template v-if="doc.ext == 'pdf'">
                            <LoadPDF
                                :pdfFile="doc.awsLink"
                                :pdfName="doc.name"
                            />
                        </template>
                    </v-col>
                    <v-card-actions>
                        <v-btn class="ma-2" small>View Supporting Documentation</v-btn>
                    </v-card-actions>

                </v-col>

                <v-col cols="12">

                    <v-card-title>Justification</v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>A clear description of the condition that is directly proportionate to the specific
                        assessed need.
                    </v-card-subtitle>
                    <v-col cols="12">
                        <!-- <v-textarea
                          label="Enter Justification"
                          outlined
                          v-model="newJustification"
                        ></v-textarea> -->
                        <span>Justification</span>
                        <div>{{ newJustification }}</div>
                    </v-col>

                </v-col>


                <v-col cols="12">

                    <v-card-title>Previous Interventions</v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>Less Intrusive methods used that did not work. Previous positive interventions and
                        supports tried.
                    </v-card-subtitle>
                    <v-col cols="12">
                        <!-- <v-textarea
                          label="Enter Interventions"
                          outlined
                          v-model="newIntervention"
                        ></v-textarea> -->
                        <span>Interventions</span>
                        <div>{{ newIntervention }}</div>

                    </v-col>

                    <v-col cols="12" sm="12" md="3"
                           v-for="doc in newDocument2"
                           :key="doc.awsLink"
                    >
                        <!-- <v-img
                          max-height="80"
                          max-width="150"
                          :src="doc.awsLink"
                        ></v-img> -->
                        <img :src="doc.awsLink" width="150" height="75">
                        <template v-if="doc.ext == 'pdf'">
                            <LoadPDF
                                :pdfFile="doc.awsLink"
                                :pdfName="doc.name"
                            />
                        </template>
                    </v-col>


                    <v-card-actions>
                        <v-btn small @click="view = true">View Previous Interventions</v-btn>

                    </v-card-actions>

                    <v-col cols="12" v-if="view">
                        <!-- <v-textarea
                          label="Previous Interventions"
                          outlined
                          v-model="previousIntervention"
                        ></v-textarea> -->
                        <span>Previous Intervention</span>
                        <div>{{ previousIntervention }}</div>

                    </v-col>

                </v-col>

                <v-col cols="12">

                    <v-card-title>Data Collection</v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>Regular collection and review of data of measure effectiveness.</v-card-subtitle>
                    <v-card-actions>
                        <v-btn
                            class="ma-2"
                            small
                            @click="goToReport()"

                        >View Data Collection
                        </v-btn>

                    </v-card-actions>

                </v-col>


                <v-col cols="12">

                    <v-card-title>Review</v-card-title>
                    <v-divider></v-divider>

                    <v-card-subtitle>Establish time limits for period reviews to determine if it is still necessary or
                        can be terminated.
                    </v-card-subtitle>
                    <v-col cols="12">
                        <!-- <v-textarea
                          label="Enter Review Details Include Restoration and Fade Plan"
                          outlined
                          v-model="newReview"
                        ></v-textarea> -->
                        <span>Review Details Include Restoration and Fade plan</span>
                        <div>{{ newReview }}</div>
                    </v-col>

                </v-col>

                <v-col cols="12">

                    <v-card-title>Select Review Period</v-card-title>
                    <v-divider></v-divider>
                    <v-row class="pl-4">
                        <v-col md="2" xs="3">
                            <v-checkbox
                                label="30 Days"
                                v-model="new30"
                            ></v-checkbox>
                        </v-col>
                        <v-col md="2" xs="3">
                            <v-checkbox
                                label="60 Days"
                                v-model="new60"
                            ></v-checkbox>
                        </v-col>
                        <v-col md="2" xs="3">
                            <v-checkbox
                                label="90 Days"
                                v-model="new90"
                            ></v-checkbox>
                        </v-col>

                        <v-col md="2" xs="3">
                            <v-checkbox
                                label="6 Months"
                                v-model="new6"
                            ></v-checkbox>
                        </v-col>

                        <v-col md="4" xs="3">
                            <v-checkbox
                                label="12 Months"
                                v-model='new12'
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-col cols="12">
                        <!-- <v-textarea
                          label="Review Notes"
                          outlined
                          v-model="newReviewNotes"
                        ></v-textarea> -->
                        <span>Review Notes</span>
                        <div>{{ newReviewNotes }}</div>
                    </v-col>


                </v-col>

                <div class="pageBreak"></div>


                <v-col cols="12">

                    <v-card-title>Informed to consent of the individual. Assurance that interventions and supports will
                        cause no harm to the individual.
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-checkbox
                            v-model="newClientConsent"
                            label="Client Informed Consent"
                            @click="showSignaturePadClient = true"
                            :disabled="readonly"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <img :src="newClientSignature" width="150" height="75">
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-checkbox
                            v-model="newGuardianConsent"
                            label="Guardian Signature"
                            @click="showSignaturePadGuardian = true"
                            :disabled="readonly"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <!-- <v-img
                          max-height="80"
                          max-width="150"
                          :src="newGuardianSignature"
                        ></v-img> -->
                        <img :src="newGuardianSignature" width="150" height="75">
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-select
                        label="Select HRC Members"
                        :items="committee"
                        item-text="Name"
                        item-value="_id"
                        multiple
                        v-model="HRCCommittee"
                        @change="updateSignatureList(HRCCommittee)"
                        return-object
                      ></v-select>
                    </v-col> -->
                    <v-col cols="12">
                        <h3 class="ml-auto mr-auto font-weight-heavy">HRC Signatures</h3>
                    </v-col>

                    <v-col cols="12"
                           v-for="member in HRCMembers"
                           :key="member.Name"
                    >
                        {{ member.Name }}
                        <!-- <v-btn x-small @click="hrcSignaturePad(member)" v-if="member.Signature == ''" class="ma-1">Click to Sign</v-btn>
                        <v-btn x-small @click="removeSignature(member)" class="ma-1">Remove</v-btn> -->

                        <v-col cols="12" id="section-to-print">
                            <!-- <v-img
                              max-height="80"
                              max-width="150"
                              :src="member.Signature"
                            ></v-img> -->
                            <img :src='member.Signature' width="150" height="75"/>

                        </v-col>
                    </v-col>


                </v-col>

                <v-col cols="12">

                    <v-card-title>Human Rights Restriction Status</v-card-title>
                    <v-divider></v-divider>
                    <v-radio-group
                        class="pa-2"
                        v-model="newStatus"
                    >
                        <v-radio
                            label="Active"
                            value="Active"
                        >
                        </v-radio>
                        <v-radio
                            label="Faded"
                            value="Faded"
                        >
                        </v-radio>
                    </v-radio-group>

                </v-col>

                <!-- <v-col cols="12">
                  Completed Signatures

                    <v-card-title
                      v-for="sig in AllSignatures"
                      :key="sig.ID"
                    >{{sig.Name}}

                    <v-img
                        max-height="80"
                        max-width="150"
                        :src="sig.Signature"
                    ></v-img>
                    </v-card-title>

                </v-col> -->

            </v-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import SignaturePad from "@/components/SignaturePad"
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import renameFileHelper from '../../mixins/renameFileHelper'
import LoadPDF from '../../components/LoadPDF.vue'
import {mapActions} from "vuex";
import momentTz from "moment-timezone";
import reports from "@/mixins/reports";


const url = require("../../client_config/config").url;

export default {
    mixins: [renameFileHelper, reports],
    components: {
        ClientNav,
        ClientSide,
        Foot,
        LoadPDF,
        SignaturePad
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'HRC Start Date',
                    align: 'start',
                    sortable: true,
                    value: 'StartDate',
                },
                {text: "Rights Restriction", value: "Restriction"},
                {text: "Justification", value: "Justification"},
                {text: "Date Expires", value: "DateExpires"},
                {text: "Date Reviewed", value: "ReviewDate"},
                {text: "Status", value: "Status"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            printHeaders: [
                {
                    text: 'HRC Start Date',
                    align: 'start',
                    sortable: true,
                    value: 'StartDate',
                },
                {text: "Rights Restriction", value: "Restriction"},
                {text: "Justification", value: "Justification"},
                {text: "Date Expires", value: "DateExpires"},
                {text: "Date Reviewed", value: "ReviewDate"},
                {text: "Status", value: "Status"},
            ],
            tab: null,
            items: ["Active", "Faded"],
            faded:[],
            search: "",
            view: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,
            dialog: false,
            editRight: false,
            newRight: false,
            msg: false,
            text: "",
            rights: [],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem('userID'),
            tempData: [],
            tempData2: [],
            titleForm: "New Human Rights Restriction",
            rightID: "",
            newReviewDate: "",
            newDateExpires: "",
            newDateNotified: "",
            newPreparedBy: "",
            newRestriction: "",
            newJustification: "",
            newIntervention: "",
            previousIntervention: "",
            newReview: "",
            newReviewNotes: "",
            new30: false,
            new60: false,
            new90: false,
            new6: false,
            new12: false,
            newClientConsent: false,
            newClientSignature: "",
            newGuardianConsent: false,
            newGuardianSignature: "",
            newHRCConsent: false,
            newHRCSignature: "",
            newChairperson: "",
            newNameTitle: "",
            AllSignatures: [],
            editedIndex: -1,
            isLoading: true,
            clientsignaturepad: false,
            guardiansignaturepad: false,
            guardiansignaturepadpop: false,
            hrcsignaturepad: false,
            committee: [],
            HRCCommittee: "",
            HRCMembers: [],
            HRCCompletedSignatures: [],
            memberID: "",
            memberName: "",
            memberSignature: "",
            newDocument: [],
            newDocument2: [],
            uploadFile: "",
            uploadFile2: "",
            staff: localStorage.getItem("Name"),
            newSignature: "",
            directCare: false,
            readonly: false,
            newStatus: "",
            showSignaturePadClient: false,
            showSignaturePadGuardian: false,
            totalServerItems: 0,
            itemsPerPage: 10,
            page: 1,
            timezone: momentTz.tz.guess(),

        };
    },

    computed: {
        formTitle() {
            return this.editedIndex != 1 ? "New Item" : "Edit Item";
        },
        clientName() {
            if (this.$store.state.clients.client) {
                return this.$store.state.clients.client.Name;
            }
            return '';
        },
        activeRights() {
            return this.rights.length;
        },
        fadedRights() {
            return this.faded.length;
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.getCommittee();
        this.getClientInfo(this.clientID)
        if (localStorage.getItem('userRole') == 'Direct Care Staff' ||
            localStorage.getItem('userRole') == 'Shift Lead' ||
            localStorage.getItem('userRole') == 'Assistant Manager' ||
            localStorage.getItem('userRole') == 'House Manager' ||
            localStorage.getItem('userRole') == 'Program Manager'
        ) {
            this.directCare = true;
            this.readonly = true;
        }
    },

    methods: {
        ...mapActions({
            getClientInfo: "clients/getClient",
        }),

        initialize() {
            this.rights = [];
        },

        viewRight(item) {

            this.$router.push({
                path: `/rights/${this.clientID}/update/${item._id}`,
                query: {createHumanRights: false}
            })

        },
        showAdd() {

            this.$router.push({
                path: `/rights/${this.clientID}/new`,
                query: {createHumanRights: true}
            })
        },

        deleteRight(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this human rights restriction?") &&
            this.rightDelete(id);

        },

        rightDelete(id) {
            axios.delete(`${url}/rights/${id}`)
                .then((response) => {
                    this.getRights();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The human right restriction has been deleted successfully.";
                });
        },

        getRights(item = {page: 1, itemsPerPage: 10}) {
            this.isLoading = true;

            const query = {
                page: item.page,
                limit: item.itemsPerPage,
                search: this.search,
                tz: this.timezone
            }

            axios.get(`${url}/rights/client/${this.clientID}`, {params: query}).then(res => {
                this.rights = []
                this.rights = res.data.rights.docs.filter(item => item?.Status === "Active");
                this.faded = res.data.rights.docs.filter(item => item?.Status === "Faded");
                this.totalServerItems = res.data.rights.totalDocs;
            }).finally(() => this.isLoading = false);
        },

        async getCommittee() {
            await axios.get(`${url}/users/committee`).then(res => {
                this.committee = res.data.users
                this.HRCMembers = [];
                for (var i = 0; i < this.committee.length; i++) {
                    var newSignature = {
                        ID: this.committee[i]._id,
                        Date: "",
                        Name: this.committee[i].Name,
                        Signature: "",
                    }
                    this.HRCMembers.push(newSignature)
                }
            })
        },

        signatureDataClient(data) {
            this.newClientSignature = data;
        },

        signatureDataGuardian(data) {
            this.newGuardianSignature = data;
        },

        hrcSignaturePad(member) {
            console.log(member)
            this.hrcsignaturepad = true;
            this.memberID = member.ID
        },

        hrcSignatureUndo() {
            this.$refs.hrcSignaturePad.undoSignature();
        },

        hrcSignatureClear() {
            this.$refs.hrcSignaturePad.clearSignature();
        },

        hrcSignatureCancel() {
            this.hrcsignaturepad = false;
        },

        hrcSignatureSave() {
            const {isEmpty, data} = this.$refs.hrcSignaturePad.saveSignature();
            console.log(isEmpty);
            for (var i = 0; i < this.HRCMembers.length; i++) {
                if (this.memberID == this.HRCMembers[i].ID) {
                    this.HRCMembers[i] = {
                        ID: this.HRCMembers[i].ID,
                        Date: this.HRCMembers[i].Date,
                        Name: this.HRCMembers[i].Name,
                        Signature: data,
                    }
                }
            }
            this.hrcsignaturepad = false;
        },

        updateSignatureList(HRCCommittee) {
            console.log(HRCCommittee)
            var newList = []
            newList.push(HRCCommittee[0].Name)
            var newSignature = {
                ID: HRCCommittee[0]._id,
                Date: "",
                Name: newList[0],
                Signature: "",
            }
            this.HRCMembers.push(newSignature)
            this.HRCCommittee = []

        },

        removeSignature(member) {
            let index = this.HRCMembers.indexOf(member)
            this.HRCMembers.splice(index, 1)
        },

        goToReport() {
            this.$router.push(`/HRCReport/${this.clientID}/${this.rightID}`)
            console.log(this.rightID)
            console.log(this.clientID + " client")
        },

        async fileSelected(e) {
            this.uploadFile = await this.renameFileHelper(e, this.clientName, "HumanRights");
        },

        async saveFile() {
            this.message = "";
            for (let i = 0; i < this.uploadFile.length; i++) {
                this.uploadFiles(this.uploadFile[i]);
            }
        },

        uploadFiles(file) {
            const formData = new FormData();
            formData.append('humanRights', file);
            var ct = {headers: {"content-type": "multipart/form-data"}};
            axios.post(`${url}/rights/fileuploader/${this.rightID}/${this.clientID}`, formData, ct)
                .then(res => {
                    if (res) {
                        this.getRights();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        deleteChip(index) {
            // Prompt here with text if required
            this.newDocument.splice(index, 1);
        },


        async fileSelected2(e) {
            this.uploadFile2 = await this.renameFileHelper(e, this.clientName, "HumanRights");
        },

        async saveFile2() {
            this.message = "";
            for (let i = 0; i < this.uploadFile2.length; i++) {
                this.uploadFiles2(this.uploadFile2[i]);
            }
        },

        uploadFiles2(file) {
            const formData = new FormData();
            formData.append('humanRights', file);
            var ct = {headers: {"content-type": "multipart/form-data"}};
            axios.post(`${url}/rights/fileuploader2/${this.rightID}/${this.clientID}`, formData, ct)
                .then(res => {
                    if (res) {
                        this.getRights();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        deleteChip2(index) {
            // Prompt here with text if required
            this.newDocument2.splice(index, 1);
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            document.getElementById('printItem').style.display = "none";


            window.print()

            document.getElementById('printTable').style.display = "none";


        },

        printItem() {
            document.getElementById('printItem').style.display = "block";
            document.getElementById('printTable').style.display = "none";


            window.print()

            document.getElementById('printItem').style.display = "none";

        },

        searchItem(query) {
            this.search = query || ''
            this.getRights()
        },

    },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    .pageBreak {
        clear: both;
        page-break-before: always;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}

#hrcSignaturePad {
    cursor: crosshair;
}

.signature-card .v-card__actions button {
    flex: 1 0 auto !important;
}

canvas {
    display: block;
    margin: auto;
}

#hrcSignaturePad > div {
    box-shadow: rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px,
    rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px,
    rgb(0 0 0 / 9%) 0px -3px 5px;
    margin: 15px auto;
    border-radius: 5px;
    border: none;
}

.signature-card {
    width: 700px;
}

@media only screen and (max-width: 768px) {
    .signature-card {
        width: 100%;
    }

    .btn-supporting-doc {
        width: 90%;
        font-size: .68rem !important;
    }
}

</style>
